import { SegmentTab } from '@shared/ui/segment-tabs/types';
import { OrganizationOrdersTabValues } from '@widgets/side-list-organization-orders/config/ui-constants';

export const organizationOrdersTabs = (): SegmentTab[] => {
    const ordersTab: SegmentTab = {
        title: 'Мои сделки',
        value: OrganizationOrdersTabValues.Orders,
    };
    const requestsTab: SegmentTab = {
        title: 'Мои запросы',
        value: OrganizationOrdersTabValues.Requests,
    };
    return [ordersTab, requestsTab];
};
